import './lib/antd-react19';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRoutes } from './app/router';
import { Providers } from './app/providers';
import './styles.css';

const container = document.getElementById('root');
if (container === null) throw new Error('Root element is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <Providers>
      <AppRoutes />
    </Providers>
  </StrictMode>,
);
